
<template>
    <div class="about-us-page">
        <!-- 返回按钮：只显示 "<"，无背景 -->
        <div class="back-btn" @click="goBack" title="返回">
            <span class="back-icon-text">&lt;</span>
        </div>

        <div class="about-container">
            <h1 class="about-title">关于我们</h1>
            <span class="title-underline"></span>

            <div class="about-content">
                <section class="about-section">
                    <h2 class="section-header">平台介绍</h2>
                    <p class="section-desc">
                        我们是一家专注于教育服务的科技平台，致力于为用户提供优质的学习资源、便捷的工具服务和完善的学习体验。始终以用户需求为核心，持续优化产品功能，助力用户高效学习、成长。
                        <br /><br />
                        探数蚁团队汇聚清华博士、中学特级教师、中国数学奥林匹克一级教练员与一线授课教师，依托博士团队的AI智能体技术研发能力，结合资深教师多年实战教学经验，打造智能化数理学习方案，专注培养学生数学思维。
                    </p>
                </section>

                <section class="about-section">
                    <h2 class="section-header">联系我们</h2>
                    <p class="section-desc">
                        官方邮箱：<span class="contact-email">tanyi@tanyi.cc</span><br />
                        公司地址：东莞市南城街道宏伟六路2号4栋506室
                    </p>
                </section>

                <section class="about-section">
                    <h2 class="section-header">免责声明</h2>
                    <p class="section-desc">
                        本平台提供的所有内容仅供参考，相关信息如有变更恕不另行通知。我们尽力保证信息准确性，但不对因使用本平台内容导致的任何损失承担责任。
                    </p>
                </section>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "AboutUs",
    metaInfo: {
        title: "关于我们"
    },
    mounted() {
        // 确保页面可以滚动
        document.body.style.overflow = 'auto';
        document.body.style.height = 'auto';
    },
    beforeDestroy() {
        // 离开时清理（如果全局样式需要恢复）
        document.body.style.overflow = '';
        document.body.style.height = '';
    },
    methods: {
        goBack() {
            this.$router.go(-1);
        }
    }
}
</script>

<style scoped>
.about-us-page {
    width: 100%;
    /* 
       修改点1：将 min-height 改为 height。
       只有固定了容器高度，overflow-y: auto 才能生效，
       让容器内部产生滚动条，而不是撑大容器。
    */
    height: 100vh; 
    
    overflow-y: auto;          /* 此时这个属性生效，内容超出会在该div内滚动 */
    background: #f2f3f7;
    padding: 40px 20px 60px;
    box-sizing: border-box;
    position: relative;
}

.about-container {
    max-width: 800px;
    margin: 0 auto;
    position: relative;
}

.back-btn {
    position: absolute;
    top: 20px;
    left: 20px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    cursor: pointer;
    color:rgb(81, 8, 250);
    font-size: 28px;
    font-weight: 700;
    line-height: 1;
    z-index: 10;
    transition: color 0.2s, transform 0.15s;
    -webkit-tap-highlight-color: transparent;
    user-select: none;
}

.back-btn:hover {
    color:rgb(88, 4, 243);
    transform: scale(1.08);
}

.back-btn:active {
    transform: scale(0.92);
}

.about-title {
    font-size: 32px;
    color: #1a1a2e;
    text-align: center;
    margin-bottom: 14px;
    font-weight: 700;
    margin-top: 12px;
}

.title-underline {
    display: block;
    width: 48px;
    height: 4px;
    background:rgb(74, 3, 240);
    border-radius: 2px;
    margin: 0 auto 44px;
    opacity: 0.7;
}

.about-content {
    display: flex;
    flex-direction: column;
    gap: 28px;
}

.about-section {
    position: relative;
    padding-left: 16px;
}

.section-header {
    font-size: 19px;
    color: #1a1a2e;
    margin-bottom: 10px;
    font-weight: 600;
    padding-left: 8px;
    border-left: 4px solid rgb(82, 11, 250);
    line-height: 1.4;
}

.section-desc {
    font-size: 15px;
    color: #5a5f72;
    line-height: 1.9;
    padding-left: 12px;
}

.contact-email {
    color: #4a6cf7;
    font-weight: 500;
    border-bottom: 1px dashed rgba(74, 108, 247, 0.4);
}

@media (max-width: 768px) {
    .about-us-page {
        padding: 30px 16px 50px;
    }
    .back-btn {
        top: 15px;
        left: 15px;
        font-size: 26px;
    }
    .about-title {
        font-size: 20px;
    }
    .title-underline {
        width: 36px;
        margin-bottom: 32px;
    }
    .about-content {
        gap: 22px;
    }
    .section-header {
        font-size: 17px;
    }
    .section-desc {
        font-size: 14px;
    }
}
</style>
